export const MAX_NUMBER_OF_VERSIONS = 5;

export const calculateVersionArray = ({
  noteContent,
  currentVersions = [],
  overrideExistingVersion = false,
}) => {
  const contentWithDate = { ...noteContent, timestamp: Date.now() };

  if (overrideExistingVersion) {
    // Replace the first entry
    return [contentWithDate, ...currentVersions.slice(1, 5)];
  } else {
    // Prepend and slice down to max number of versions
    return [contentWithDate, ...currentVersions].slice(
      0,
      MAX_NUMBER_OF_VERSIONS
    );
  }
};
